import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatMessage, ChatMessageRatingEnum, ChatMetadata, EngagmentConversationQuestionData, ExternalConverdationalUseCaseData, ServerResMessageData } from './chat-data';
import { ChatTypeEnum } from './chatEnum';

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractChatService {
  public abstract liveChatConnectedEvent: EventEmitter<void>;

  abstract liveChat_connect(chatId: string): void;

  abstract liveChat_sendMessage(msg: string): void;

  abstract onMessage(): Observable<string> ;

  abstract isWSConnected(): boolean;

  abstract liveChat_closeConnection():void;

  abstract getChats(): Observable<ChatMetadata[]>;

  abstract getStructuredProcessChat (processId: string, stageId: string, stepId: string): Observable<ChatMetadata | null>;

  abstract deleteChat (chatId: string): Observable<string>;

  abstract getOldMessages (chatId: string, limit?: number, beforeMessageId?: string) : Observable<ChatMessage[]>;

  abstract startNewChat (type? : ChatTypeEnum, baseObjId?: string) : Observable<ChatMetadata>;

  abstract startNewStructuredProcessChat (type: ChatTypeEnum, processId: string, stageId: string, stepId: string) : Observable<ChatMetadata>;

  abstract setUserMessage (message: string) : Observable<ServerResMessageData>;

  abstract setMessageRating (messageId: string, messageRating : ChatMessageRatingEnum): Observable<string>;

  abstract getConversationalQuestion (questionId: string): Observable<EngagmentConversationQuestionData>;

  abstract getUseCasesToChat (chatType: ChatTypeEnum): Observable<ExternalConverdationalUseCaseData[]>;

  abstract registerChatForAudio (chatId: string): Observable<string>;

  abstract unregisterChatForAudio (chatId: string): Observable<string>;

  abstract registerPeopleOfInterest (chatId: string, peopleOfInterest: string[]): Observable<string>;
}
